export const STAFF_MESSAGE_MAX_GRAPHEMES = 4000;

export function countGraphemes(text: string): number {
  try {
    const IntlAny = Intl as typeof Intl & {
      Segmenter?: new (
        l: string | undefined,
        o: { granularity: string },
      ) => { segment: (s: string) => Iterable<{ segment: string }> };
    };
    if (typeof Intl !== 'undefined' && IntlAny.Segmenter) {
      const seg = new IntlAny.Segmenter(undefined, { granularity: 'grapheme' });
      let n = 0;
      for (const _ of seg.segment(text)) n += 1;
      return n;
    }
  } catch {
    /* fallthrough */
  }
  return Array.from(text).length;
}

export function validateStaffMessageBody(body: string): { ok: true } | { ok: false; message: string } {
  const t = body?.trim?.() ?? '';
  if (!t) return { ok: false, message: 'Messaggio vuoto' };
  const n = countGraphemes(t);
  if (n > STAFF_MESSAGE_MAX_GRAPHEMES) {
    return { ok: false, message: `Messaggio troppo lungo (max ${STAFF_MESSAGE_MAX_GRAPHEMES} caratteri)` };
  }
  return { ok: true };
}
